import { Pipe, PipeTransform } from '@angular/core';
import { formatDate } from '@angular/common';

@Pipe({
    name: 'customDate',
    standalone: true
})
export class CustomDatePipe implements PipeTransform {

    private arabicMonths: string[] = [
        'يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو',
        'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'
    ];

    transform(value: any, format: string = 'dd MMM yyyy', locale: string = 'en-US', isArabic: boolean = false): string {
        let formattedDate = formatDate(value, format, locale);

        if (isArabic) {
            // Replace English month names with Arabic month names
            this.arabicMonths.forEach((arabicMonth, index) => {
                const englishMonth = new Date(0, index).toLocaleString('en-US', { month: 'short' });
                const regex = new RegExp(englishMonth, 'g');
                formattedDate = formattedDate.replace(regex, arabicMonth);
            });
        }


        return formattedDate;
    }

}